"use strict";
/**
 * Field Suggestion Database Types
 *
 * Records for user-submitted field suggestions (add/remove/modify material fields).
 * Previously defined locally in lambda-secure/src/routes/field-suggestions.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
